import { Dialog } from '@mui/material';
import React, { useState } from 'react';
import { ReactComponent as CrossIcon } from "assets/img/svg/CrossIcon.svg";
import { AGridColDef } from '../../../../../common/data-grid/ADataGridColDef';
import { gridComponents, gridStyles } from '../../../../../edpOps/issuanceIDcard/printIdCardAndMapRfid/constant';
import ADataGrid from '../../../../../common/data-grid/ADataGrid';
import AButton from '../../../../../common/form-fields-mui/AButton';
import { applyAdjustment } from './utils';
import { successToast } from '../../../../../common/utils/methods/toasterFunctions/function';
import { formattedPrice } from '../../../../../edpOps/studentDetails/paymentSummary/advancePaymentDetails/paymentDialog/constant';
import CustomChip from '../../../../../common/customChip/CustomChip';


const SecurityAdjustmentsListingDialog = ({
  open,
  setOpen,
  applicationDetails,
  adjustmentsList,
  securityChargeDetails,
  setLoading,
  getSecurityAdjustments,
  closeSearchDialog,
  fetchOtherChargesList,

}) => {

  const [selectionModel, setSelectionModel] = useState([]);

  const handleClose = () => {
    setOpen(false);
  }

  const selectedAdjustment = adjustmentsList?.find(el => el?.oldScholarshipTransactionId === selectionModel[0]);
 let  adjustmentAmount =  securityChargeDetails?.netBalance - (selectedAdjustment?.amount ?? 0)
 adjustmentAmount  = adjustmentAmount<0?0:adjustmentAmount
  const applyAdjustmentClickHandler = async () => {
    try {
      setLoading(true);
      const resp = await applyAdjustment(selectedAdjustment, applicationDetails, securityChargeDetails);
      if (resp?.code === 200) {
        successToast("Adjustment applied successfully!");
        // getSecurityAdjustments(selectedAdjustment?.psid);
        setSelectionModel([]);
        fetchOtherChargesList();
        closeSearchDialog();
        handleClose();
      }

    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  const columns = [
    new AGridColDef("psid", "PSID", false)
      .setMinWidth(80)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("mobNo", "Mobile No", false)
      .setMinWidth(120)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter(() => applicationDetails?.phoneNo),

    new AGridColDef("applicationId", "Application Number", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("regularCourseId", "Regular Course Id", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("regularTerm", "Regular Term", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("securityCourseId", "Security Course Id", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("securityTerm", "Security Term", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .setValueGetter((params) => params?.value),

    new AGridColDef("amount", "Amount", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .renderCellComponent((params) => <div>{formattedPrice(params?.value)}</div>),

    new AGridColDef("status", "Status", false)
      .setMinWidth(110)
      .setFlex(0.8)
      .editable(true)
      .pinColumnLast(true)
      .renderCellComponent(params => {
        return (
          <CustomChip
            text={"Paid"}
            textColor='#FFF'
            bgColor='#059669'
          />
        )
      })
  ]

  return (
    <Dialog
      open={open}
      fullWidth
      maxWidth="md"
    >

      <div className='p-3 d-flex flex-column'>

        <div className='d-flex justify-content-between'>
          <h2>Security adjustments</h2>

          <CrossIcon onClick={handleClose} />
        </div>

        <h4 className='mb-1'>Select a new SD ID</h4>

        <div
          style={{
            margin: '0.75rem 0px',
            padding: '0.75rem',
            border: '1px solid #bfbfbf',
            borderRadius: '8px'
          }}
        >

          <ADataGrid
            // removeWrapperContainer
            rows={adjustmentsList || []}
            columns={columns}
            rowId={(row) => row?.oldScholarshipTransactionId}
            rowHeight={50}
            loading={false}
            components={{
              ...gridComponents,
              // ...dataGridRoundCheckBoxes
            }}
            sx={gridStyles}
            height={200}
            hidePagination
            checkboxSelection={true}
            selectionModel={selectionModel}
            disableSelectionOnClick
            disableMultipleRowSelection
            hideFooterSelectedRowCount
            onSelectionModelChange={(newSelectionModel) => {
              const modelLength = newSelectionModel?.length
              const updatedSelectionModel = modelLength > 1 ? [newSelectionModel[modelLength - 1]] : newSelectionModel;
              setSelectionModel(updatedSelectionModel);
            }}
            pinLastColumn
          // checkbox={dataGridRoundCheckBoxes}
          />

        </div>


        <div className='d-flex justify-content-between my-2'>
          <div>Net payable after adjustment</div>
          <div style={{ fontWeight: 700, fontSize: '16px', color: '#05945B' }}>{formattedPrice(adjustmentAmount)}</div>
        </div>

        <AButton
          variant='primary_filled'
          className='no-ml-btn w-25'
          disabled={selectionModel.length === 0}
          onClick={applyAdjustmentClickHandler}
        >
          Apply Adjustment
        </AButton>
      </div>

    </Dialog>
  );
}

export default SecurityAdjustmentsListingDialog;